export const MARKET_REGIME = 'market-regime';
export const GENIE = 'genie';
export const APP = 'app';
